// extracted by css-extract-rspack-plugin
export default {"panel_spacer":"pFfi2","panelSpacer":"pFfi2","panel_buttons":"ZmwPJ","panelButtons":"ZmwPJ","back_button_override":"SauqN","backButtonOverride":"SauqN","#":"VyV9U"};